/**
 * Widget 悬浮按钮组件
 *
 * 设计规范：
 * - 位置：右侧中部 (right: 24px, top: 50%)
 * - 样式：圆形蓝色按钮，56x56px
 * - 动画：呼吸效果 (pulse)
 * - 交互：点击打开 Widget
 */

import React from 'react';
import { clsx } from 'clsx';

export interface LauncherButtonProps {
  /** 是否可见 */
  visible?: boolean;
  /** 点击回调 */
  onClick: () => void;
  /** 主题颜色 */
  themeColor?: string;
  /** 自定义 CSS 类名 */
  className?: string;
}

export const LauncherButton: React.FC<LauncherButtonProps> = ({
  visible = true,
  onClick,
  themeColor,
  className
}) => {
  return (
    <button
      className={clsx(
        'cs-launcher',
        !visible && 'cs-hidden',
        className
      )}
      style={
        themeColor ? ({ '--cs-theme-color': themeColor } as React.CSSProperties) : undefined
      }
      onClick={onClick}
      aria-label="打开智能客服"
      type="button"
    >
      {/* 机器人图标 */}
      <svg
        className="cs-launcher-icon"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>

      {/* 内联样式（Shadow DOM 内） */}
      <style>{`
        .cs-launcher {
          position: fixed;
          right: 24px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 9998;
          width: 56px;
          height: 56px;
          background: var(--cs-theme-color, #2563EB);
          border-radius: 50%;
          border: none;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          animation: cs-pulse 2s ease-in-out infinite;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .cs-launcher:hover {
          transform: translateY(-50%) scale(1.07);
          animation-duration: 1s;
        }

        .cs-launcher:active {
          transform: translateY(-50%) scale(0.95);
        }

        .cs-launcher.cs-hidden {
          opacity: 0;
          pointer-events: none;
          transform: translateY(-50%) scale(0.8);
        }

        .cs-launcher-icon {
          color: white;
        }

        @keyframes cs-pulse {
          0%, 100% {
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
          }
          50% {
            box-shadow: 0 4px 20px rgba(37, 99, 235, 0.5);
          }
        }
      `}</style>
    </button>
  );
};
